module.exports = __webpack_public_path__ + "img/banner2_4_en.b24c34b1.png";